export const iconFontAwesomeMediaplaybackArrowRotateRight = (
	<i className="fa-solid fa-arrow-rotate-right"></i>
);
